export class ApiError extends Error {
    code;
    data;
    status;
    path;
    detail;
    constructor(params) {
        super(params.code);
        Object.assign(this, params);
    }
}
